module.exports = __webpack_public_path__ + "img/3Dearth.7653e869.jpeg";